import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdbe9f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "custom_alert" }
const _hoisted_2 = { class: "window" }
const _hoisted_3 = { class: "content-header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", null, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "content-text"
}
const _hoisted_8 = { class: "text" }
const _hoisted_9 = {
  key: 1,
  class: "content-text"
}
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_CloseBtn = _resolveComponent("CloseBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require(`@/assets/images/popup_${_ctx.imgName}.jpg`),
          class: "popup-img"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.type === 'donePopup')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.t(_ctx.title)), 1),
                _createElementVNode("ol", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.t("DONE.CANNOT_DOWNLOAD.POINT1")), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.t("DONE.CANNOT_DOWNLOAD.POINT2", { rmaCode: _ctx.rmaCode })), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t(_ctx.title)), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t(_ctx.text)), 1)
            ])),
        (_ctx.btnText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.emitsWithEmitter)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    text: _ctx.t(_ctx.btnText),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {
              _ctx.$emit(_ctx.btnAction);
              _ctx.emitWithEmmiter(_ctx.btnAction);
            }),
                    "data-cy": "logout-btn"
                  }, null, 8, ["text"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    text: _ctx.t(_ctx.btnText),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_ctx.btnAction))),
                    "data-cy": "logout-btn"
                  }, null, 8, ["text"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasCloseBtn)
          ? (_openBlock(), _createBlock(_component_CloseBtn, {
              key: 3,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit(_ctx.xBtnAction))),
              round: true
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}